import events from "."

events.on("page-loaded", () => {
  const body = document.querySelector("body")
  body.classList.remove("page-loading")
})
